import { Plane } from "lucide-react";
import { cn } from "@/shared/lib/cn";

interface BrandLogoProps {
  className?: string;
  iconOnly?: boolean;
}

export function BrandLogo({ className, iconOnly }: BrandLogoProps) {
  return (
    <div className={cn("flex items-center gap-2", className)}>
      <div className="flex items-center justify-center h-8 w-8 rounded-lg gradient-ocean text-white">
        <Plane className="h-4 w-4" />
      </div>
      {!iconOnly && (
        <span className="font-heading font-bold text-lg text-sand-900 dark:text-sand-100">
          Tour<span className="text-ocean-500">Flow</span>
        </span>
      )}
    </div>
  );
}
